import { getDataFromServer } from '../../../util';

export class SegmentListModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchSegmentList = async (payload) => {
    const params = {
      metaName: 'segment'
    };

    const url = `${this.baseURL}/meta`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (Array.isArray(data) && data.length > 0) {
      return data.map((segmentItem) => {
        const { segmentName, segmentCode } = segmentItem;
        return {
          label:
            segmentName && segmentName.trim() !== ''
              ? segmentName
              : segmentCode
              ? segmentCode
              : '',
          value: segmentCode ? segmentCode : ''
        };
      });
    }

    return [];
  };
}
